var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';
import isEqual from 'lodash/isEqual';
import { useAccountActivityQuery } from 'syf-api';
import { useActivityContext } from '../context/activity-store';
import { activityQuery, defaultActivityData } from '../helpers/activity-query';
import { activityCacheKey } from '../services/activity/activity-cache-keys';
import { appendActivityData, getNormalizedData } from '../helpers/utils/activity-utils';
var getActivityQueryProps = function (_a) {
    var accountId = _a.accountId, accountIdType = _a.accountIdType, activeFilter = _a.activeFilter, config = _a.config, cursor = _a.cursor;
    var activityQueryKeyProps = {
        accountId: accountId,
        accountIdType: accountIdType,
        cursor: cursor,
        filterByValue: activeFilter !== 'all' ? activeFilter : undefined
    };
    return {
        config: config,
        keyProps: __assign({}, activityQueryKeyProps),
        queryOptions: {
            enabled: Boolean(accountId),
            queryKey: activityCacheKey(__assign(__assign({}, activityQueryKeyProps), { nextCursor: cursor || undefined })),
            queryFn: activityQuery(__assign(__assign({}, activityQueryKeyProps), { nextCursor: cursor || '', config: config }))
        }
    };
};
var useActivityData = function (_a) {
    var accountId = _a.accountId, accountIdType = _a.accountIdType, config = _a.config, isDisplayCondensed = _a.isDisplayCondensed;
    var _b = useActivityContext(), cursor = _b.cursor, nextCursor = _b.nextCursor, setNextCursor = _b.setNextCursor, setIsLoadingMoreData = _b.setIsLoadingMoreData, activeFilter = _b.activeFilter;
    var activityQueryArgs = getActivityQueryProps({
        accountId: accountId,
        accountIdType: accountIdType,
        activeFilter: activeFilter,
        config: config,
        cursor: cursor
    });
    var _c = useAccountActivityQuery(activityQueryArgs), data = _c.data, isFetching = _c.isFetching, refetch = _c.refetch, isError = _c.isError, isSuccess = _c.isSuccess;
    var _d = useState(false), isDataPopulated = _d[0], setIsDataPopulated = _d[1];
    var _e = useState(defaultActivityData), activityData = _e[0], setActivityData = _e[1];
    var accountActivityData = data;
    var hasMoreTransactions = !!nextCursor;
    var normalizedData = useMemo(function () {
        return getNormalizedData(accountActivityData);
    }, [data]);
    var isIdenticalData = isEqual(normalizedData, activityData);
    var refetchAccountActivity = function () {
        if (!nextCursor) {
            refetch();
        }
    };
    useEffect(function () {
        var _a;
        if (isSuccess) {
            setIsLoadingMoreData(false);
            setIsDataPopulated(true);
        }
        var apiNextCursor = (_a = accountActivityData === null || accountActivityData === void 0 ? void 0 : accountActivityData.pageMetaData) === null || _a === void 0 ? void 0 : _a.nextCursor;
        if (apiNextCursor) {
            setNextCursor(apiNextCursor);
        }
        if (!apiNextCursor && apiNextCursor !== undefined) {
            setNextCursor('');
        }
        // appending activity data if there are more transactions to be shown
        if (hasMoreTransactions && !isIdenticalData) {
            var appendedData = appendActivityData(normalizedData, activityData);
            setActivityData(appendedData);
            return;
        }
        if (!hasMoreTransactions && isError) {
            setActivityData(defaultActivityData);
            return;
        }
        setActivityData(normalizedData);
    }, [data, isIdenticalData, isError]);
    var activity = (activityData === null || activityData === void 0 ? void 0 : activityData.activity) || defaultActivityData.activity;
    var showLoadMore = hasMoreTransactions && activity.itemsIds.length > 0 && !isDisplayCondensed;
    return {
        activity: activity,
        isError: isError,
        isFetching: isFetching,
        isSuccess: isSuccess && isDataPopulated,
        refetchAccountActivity: refetchAccountActivity,
        showLoadMore: showLoadMore
    };
};
export default useActivityData;
//# sourceMappingURL=use-activity-data.js.map